import { useEffect, useRef, useState } from 'react';
import api from '../../../../services/api';
import { useTopologyBase } from './topologyApi';

/**
 * Hook: polling do tráfego por edge a cada N segundos.
 * Retorna { traffic: { edge_id: {in_bps, out_bps, a_iface, b_iface} }, loading }
 */
export default function useTopologyTraffic({ intervalMs = 15000, enabled = true } = {}) {
  const base = useTopologyBase();
  const [traffic, setTraffic] = useState({});
  const [loading, setLoading] = useState(false);
  const timerRef = useRef(null);

  const fetchTraffic = async () => {
    if (!base || !enabled) return;
    try {
      const res = await api.get(`${base}/traffic`);
      setTraffic(res.data?.traffic || {});
    } catch {
      // silencioso
    }
  };

  useEffect(() => {
    if (!base || !enabled) {
      setTraffic({});
      return;
    }
    setLoading(true);
    fetchTraffic().finally(() => setLoading(false));
    if (timerRef.current) clearInterval(timerRef.current);
    timerRef.current = setInterval(fetchTraffic, intervalMs);
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [base, enabled]);

  return { traffic, loading };
}
